import { Card } from '@chakra-ui/react'
import type { ComponentProps } from 'react'
import { glassPanel } from '@/shared/lib/chakra/glass'

/** Light mode: soft white card. Dark mode: frosted glass over the page wash. */
function Root({ children, ...props }: ComponentProps<typeof Card.Root>) {
  return (
    <Card.Root {...glassPanel} borderRadius="xl" overflow="hidden" {...props}>
      {children}
    </Card.Root>
  )
}

export const AppCard = {
  Root,
  Body: Card.Body,
  Header: Card.Header,
  Footer: Card.Footer,
  Title: Card.Title,
  Description: Card.Description,
}
